import React from "react";
import * as styles from "./Select.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import ReactSelect from "react-select";

const Select = ({
	label,
	options,
	placeholder,
	field,
	form,
	disabled = false,
	className,
	isMulti = false,
	isSearchable = false,
	selectAllOption,
	onChange: onChangeProp,
}) => {
	const selectClassName = classNames({
		[styles["select"]]: true,
		[className]: !!className,
	});
	let currentValue;
	if (!isMulti) {
		currentValue = options ? options.find((option) => option.value === field.value) : "";
	} else {
		currentValue = options ? options.filter((option) => field.value.includes(option.value)) : [];
	}
	currentValue = isMulti && typeof currentValue === "string" ? [currentValue] : currentValue;
	const displayOptions = selectAllOption
		? [
				{
					value: "__all_options__",
					label: <i>{selectAllOption}</i>,
					selected: false,
				},
				...options,
			]
		: options;

	return (
		<div className={selectClassName}>
			{label && <Form.Label>{label}</Form.Label>}
			<ReactSelect
				options={displayOptions}
				name={field.name}
				value={currentValue || null}
				onChange={(option) => {
					if (onChangeProp) {
						onChangeProp(isMulti ? option.map(({ value }) => value) : option.value, option);
					} else if (selectAllOption && option?.find?.(({ value }) => value === "__all_options__")) {
						const allValues = options.map(({ value }) => value);
						form.setFieldValue(field.name, allValues);
					} else {
						form.setFieldValue(field.name, isMulti ? option.map(({ value }) => value) : option.value);
					}
				}}
				onBlur={field.onBlur}
				classNamePrefix={"react-select"}
				placeholder={placeholder}
				disabled={disabled}
				theme={(theme) => ({
					...theme,
					borderRadius: 0,
					colors: {
						primary: "#fff",
					},
				})}
				isMulti={isMulti}
				isSearchable={isSearchable}
			/>
		</div>
	);
};

Select.propTypes = {
	label: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		}).isRequired,
	),
	name: PropTypes.string,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	className: PropTypes.string,
};

export default Select;
